import React, {FC} from "react"
import styled from "styled-components"

import Flex from "@irati/ui/src/Flex"
import {useTheme} from "@irati/ui/src/global/useTheme"
import {H6} from "@irati/ui/src/Typography"

const Image = styled.img`
  width: 80px;
  height: 80px;
`

interface Props {
  img: string
  text: string
  width?: string
}

const Brand: FC<Props> = ({img, text, width}) => {
  const theme = useTheme()
  return (
    <Flex direction="column" justifyContent="center" alignItems="center" width={width || "130px"}>
      <Image src={img} />
      <H6 color={theme.colors.primary2}>{text}</H6>
    </Flex>
  )
}
export default Brand
